(function(angular){
	'use strict';

	angular.module('fiveYearReturnsChartModule', [
		'coreModule'
	]);
	
})(window.angular);